import { useCallback } from 'react';

import { disableCaptions, enableCaptions } from '../../../actions/preferencesActions';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useStudentSelector } from '../../../store/selectors/useStudentSelector';

export const useAreAudioCaptionsEnabled = () => useStudentSelector((state) => state.preferences.captionsEnabled);

export const useToggleAudioCaptions = (areAudioCaptionsEnabled: boolean) => {
  const dispatch = useAppDispatch();
  const toggleCaptions = useCallback(() => {
    if (areAudioCaptionsEnabled) {
      dispatch(disableCaptions);
      return;
    }

    dispatch(enableCaptions);
  }, [dispatch, areAudioCaptionsEnabled]);

  return toggleCaptions;
};
